module.exports = __webpack_public_path__ + "img/pnevmoinstrument.4f6d109d.svg";